import 'whatwg-fetch';

async function get(url, headers = {}) {
  return request(url, createOperation('get', '', headers));
}

async function post(url, data, headers = {}) {
  return request(url, createOperation('post', data, headers));
}

async function del(url, headers = {}) {
  return request(url, createOperation('delete', '', headers));
}

async function put(url, data, headers = {}) {
  return request(url, createOperation('put', data, headers));
}

async function request(url, options) {
  const response = await fetch(url, options);
  let responseJSON;
  try {
    responseJSON = await response.json();
  } catch (e) {
    responseJSON = {};
  }

  if (!response.ok) {
    throw { status: response.status, ...responseJSON };
  }
  return responseJSON;
}

function createOperation(method, data, customHeaders = {}) {
  const result = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...customHeaders,
    },
  };

  if (data) {
    result.body = JSON.stringify(data);
  }

  const token = document.getElementsByName('csrf-token')[0].content;

  if (token != null) {
    result.headers['X-CSRF-TOKEN'] = token;
  }
  return result;
}

export const fetcher = {
  get,
  post,
  del,
  put,
};

window.fetcher = fetcher;
